import { loc } from "../../../core/utils"
import React from "react"
import { Button } from "react-bootstrap"

const CreateOrderButton = ({ packContext, isLoading, product, createOrder, showCreateOrderButton }) => {
  if (!showCreateOrderButton) return null
  return (
    <Button
      variant="success"
      className="submit"
      onClick={() => createOrder(packContext)}
      disabled={isLoading || !(product && packContext.shop.value && packContext.delivery.value)}
    >
      {loc("Validate")}
    </Button>
  )
}

export default CreateOrderButton
